module.exports = __webpack_public_path__ + "assets/img/offie-modal-logo.332ff327.svg";